/**
 * Get platform display name
 * @param platform - The platform key
 * @returns Display name for the platform
 */
export const getPlatformDisplayName = (platform: 'mac' | 'win32' | 'linux'): string => {
  switch (platform) {
    case 'mac':
      return 'macOS';
    case 'win32':
      return 'Windows';
    case 'linux':
      return 'Linux';
    default:
      return platform;
  }
};

/**
 * Get platform button color
 * @param platform - The platform key
 * @returns CSS color for the platform button
 */
export const getPlatformColor = (platform: 'mac' | 'win32' | 'linux'): { backgroundColor: string; color: string } => {
  switch (platform) {
    case 'mac':
      return { backgroundColor: '#007bff', color: 'white' };
    case 'win32':
      return { backgroundColor: '#28a745', color: 'white' };
    case 'linux':
      return { backgroundColor: '#ffc107', color: 'black' };
    default:
      return { backgroundColor: '#6c757d', color: 'white' };
  }
};
